var render = function render(){var _vm=this,_c=_vm._self._c;return _c('prompt',{attrs:{"title":_vm.$t(`title`),"label":_vm.$t(`paymentMethod`),"defaultValue":_vm.$t(`pleaseEnterCompanyName`),"placeholder":"ex. 悠遊餐飲國際有限公司"},on:{"confirm":v => _vm.setOrderParams({ invoiceTitle: v })}})
}
var staticRenderFns = []

export { render, staticRenderFns }